import { Table, Card, Image } from "react-bootstrap";
import { CustomAd } from "../../utils/interface";
import React from "react";
import { Config } from "../../common";
import UpdateCustomAd from "../UpdateCustomAd";

interface ListCustomAdsProps {
  ads: CustomAd[];
  onUpdateAd: (customAdId: number, formData: FormData) => void;
}

const ListCustomAds: React.FC<ListCustomAdsProps> = ({
  ads,
  onUpdateAd,
}) => {
  return (
    <Card className="shadow-sm">
      <Card.Header>
        <h5 className="mb-0">All Advertisements</h5>
      </Card.Header>

      <Card.Body>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>#ID</th>
              <th>Preview</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {ads?.length > 0 ? (
              ads.map((ad) => (
                <tr key={ad.customAdId}>
                  <td>{ad.customAdId}</td>

                  <td>
                    <Image
                      src={`${Config.server.baseUrl}/${ad.contentLocation}`}
                      alt="ad"
                      thumbnail
                      width={80}
                      height={80}
                      style={{ objectFit: "cover" }}
                    />
                  </td>

                  <td>
                    <UpdateCustomAd adData={ad} onSubmit={onUpdateAd} />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center text-muted py-4">
                  No Ads Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default ListCustomAds;
